import React, { useState } from 'react'
import { Box, Textfield, SwxTheme } from 'swx-atomic-component-lib'
import _ from 'lodash'
import {
  textFieldStyle,
  commonTextFieldWrapperStyle,
  iconRowStyle,
  formRowStyle,
  iconStyle
} from './style'

import EmailIcon from 'calcite-ui-icons-react/EnvelopeIcon'
import i18n from '../../../i18n'

function EmailFormComponent (props) {
  const [emailError, setEmailError] = useState(false) // eslint-disable-line

  const emailDebounced = _.debounce(onEmailChange, 275)

  const { emailValue, emailChange, readOnly } = props

  // This is for reset
  // useEffect((a) => {
  //   if (emailValue === '') {
  //     setEmailError(false)
  //   }
  // }, [emailValue, setEmailError])

  function onEmailChange (value, elem) {
    if (!elem.validated || value === '') {
      setEmailError(true)
    } else {
      setEmailError(false)
    }

    emailChange(value, !elem.validated)
  }

  return (
    <Box customStyle={formRowStyle}>
      <Box customStyle={iconRowStyle}>
        <EmailIcon size={16} color={SwxTheme.palette.primary} style={iconStyle} className='mobile-hide' />
      </Box>
      <Box customStyle={commonTextFieldWrapperStyle} ml={3}>
        <Textfield
          type='email'
          placeholder={i18n.signUpPage.placeholder.email}
          customStyle={textFieldStyle}
          round
          value={emailValue}
          onChange={emailDebounced}
          error={emailError}
          message={i18n.signUpPage.error.email}
          color='primary'
          tabIndex='3'
          readOnly={readOnly}
        />
      </Box>
    </Box>
  )
}

export default EmailFormComponent
